export default "__VITE_ASSET__B68uL73B__"